export const DASHBOARD_PATCH = 'DASHBOARD_PATCH';
export const DASHBOARD_RESET_BUILDER = 'DASHBOARD_RESET_BUILDER';
export const DASHBOARD_CLEAR = 'DASHBOARD_CLEAR';
export const DASHBOARD_ADD_WIDGET = 'DASHBOARD_ADD_WIDGET';
